<template>
  <div>
    <el-row :getter="15">
      <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="17">
        <!-- html -->
        <quill-editor
          ref="myQuillEditor"
          v-model="hContent"
          v-show="isCheck"
          :options="editorOption"
          :style="'height:' + height"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @ready="onEditorReady($event)"
          @change="onEditorChange($event)"
        />
        <!-- markdowm -->
        <mavon-editor
          ref="md"
          v-show="!isCheck"
          v-model="mContent"
          :style="'height:' + height"
          @imgAdd="imgAdd"
        />
      </el-col>

      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="7">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <el-tooltip
              style="margin-right: 10px"
              class="item"
              effect="dark"
              content="提取指定的标签用于访问文章"
              placement="top"
            >
              <span class="role-span">标签提取</span>
            </el-tooltip>
            <el-button
              size="mini"
              class="artice-content"
              type="primary"
              @click="lastArtice"
              >上一篇</el-button
            >
            <el-button
              size="mini"
              class="artice-content"
              type="primary"
              @click="nextArtice"
              >下一篇</el-button
            >
            <el-button
              size="mini"
              class="artice-operation"
              type="primary"
              :disabled="!showButton"
              @click="postArticle"
              >发布</el-button
            >
            <el-button
              size="mini"
              class="artice-operation"
              type="primary"
              @click="switchType"
              >切换{{ switchText }}</el-button
            >
          </div>
          <div>
            <el-col>
              <el-tag
                style="margin: 5px"
                closable
                v-for="(item, index) in tagList"
                :key="index"
                :disable-transitions="false"
                @close="closeTag(item)"
              >
                {{ item }}
              </el-tag>
            </el-col>
            <el-autocomplete
              style="margin: 20px 5px"
              v-model="tagText"
              placeholder="请输入提取的标签"
              :fetch-suggestions="querySearchAsync"
              @change="changeEvent"
              @select="selectEvent"
            ></el-autocomplete>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

// html显示（富文本插件）
import { quillEditor } from "vue-quill-editor";
import {
  releaseArtice,
  previousPage,
  nextPage,
} from "@/network/content/artice";

import { tagList } from "@/network/content/tag";
import { articeDetails } from "@/network/content/artice";

export default {
  data() {
    return {
      height: document.documentElement.clientHeight - 200 + "px",
      detailInfo: {},
      showButton: false,
      hContent: "", //html内容
      mContent: "", //markdown内容
      isCheck: true, //是否切换 true--html false--markdown
      editorOption: {
        placeholder: "编辑文章内容",
      },
      tagList: [],
      tagText: "",
      switchText: "markdown",
      isEdit: false, //是否修改html，减少传输压力
    };
  },
  components: {
    quillEditor,
  },
  watch: {
    tagList: {
      handler(val) {
        this.showButton = val.length != 0 ? true : false;
      },
    },
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  mounted() {
    // markdown/html 获取高度
    const that = this;
    window.onresize = function temp() {
      that.height = document.documentElement.clientHeight - 200 + "px";
    };
    // 接收上个页面的参数
    this.detailInfo = JSON.parse(this.$route.query.item);
    this.getInitData();

    if (this.detailInfo.docTags != "") {
      this.tagList = this.detailInfo.docTags.split(",");
    }
    // console.log('this is current quill instance object', this.editor)
  },
  methods: {
    getInitData() {
      // $loading Loading.service
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      articeDetails({
        docId: this.detailInfo.id,
      }).then((e) => {
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.hContent = data.html;
          this.mContent = data.md;
          loading.close();
        }
      });
    },
    //手动提取标签
    changeEvent(e) {
      this.tagText = "";
      this.tagList.push(e);
    },
    //远程提取标签
    selectEvent(e) {
      this.tagText = "";
      this.tagList.push(e.value);
    },
    //删除标签
    closeTag(item) {
      this.tagList = this.tagList.filter((e) => e != item);
    },


    //发布文章
    postArticle() {
      releaseArtice({
        docTags: this.tagList.toString(),
        html: this.isEdit ? this.content : "",
        id: this.detailInfo.id,
      }).then((e) => {
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.$router.push({
            path: "/artice",
            query: {
              isRelease: true,
            },
          });
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
      });
    },

    //远程搜索
    querySearchAsync(queryString, cb) {
      let params = {
        data: {
          tagName: queryString,
        },
      };
      tagList(params).then((e) => {
        let { code, data, msg } = e.data;
        if (code == 200) {
          let result = [];
          for (let v of data.records) {
            let obj = {
              key: v.id,
              value: v.tagName,
            };
            result.push(obj);
          }
          cb(result);
        }
      });
    },


    // HTML/markdown 切换
    switchType() {
      this.isCheck = !this.isCheck;
      this.switchText = this.isCheck ? "markdown" : "html";
    },
    //上一篇
    lastArtice() {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        id: this.detailInfo.id,
      };
      previousPage(params).then((e) => {
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.hContent = data.html;
          this.mContent = data.md;
          loading.close();
        }
      });
    },
    //下一篇
    nextArtice() {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        id: this.detailInfo.id,
      };
      nextPage(params).then((e) => {
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.hContent = data.html;
          this.mContent = data.md;
          loading.close();
        }
      });
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    onEditorFocus(quill) {
      this.isEdit = true;
      console.log("editor focus!", quill);
    },
    onEditorChange({ quill, html, text }) {
      // console.log('editor change!', quill, html, text)
      this.content = html;
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    // 绑定@imgAdd event
    imgAdd(pos, $file) {
      // 第一步.将图片上传到服务器.
      var formdata = new FormData();
      
      formdata.append("image", $file);
      axios({
        url: "server url",
        method: "post",
        data: formdata,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((url) => {
        // 第二步.将返回的url替换到文本原位置![...](./0) -> ![...](url)
        /**
         * $vm 指为mavonEditor实例，可以通过如下两种方式获取
         * 1. 通过引入对象获取: `import {mavonEditor} from ...` 等方式引入后，`$vm`为`mavonEditor`
         * 2. 通过$refs获取: html声明ref : `<mavon-editor ref=md ></mavon-editor>，`$vm`为 `this.$refs.md`
         */
        $vm.$img2Url(pos, url);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.artice-content {
  padding: 6px 9px;
}
.artice-operation {
  float: right;
  padding: 6px 9px;
}
</style>